/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }

    return obj;
}

function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };

    return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}

function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [null];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }

    return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);

            _cache.set(Class, Wrapper);
        }

        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
}

function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
    }

    return _assertThisInitialized(self);
}

function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;

        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;

            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }

        return _possibleConstructorReturn(this, result);
    };
}

var Dom = /*#__PURE__*/function () {
    function Dom() {
        _classCallCheck(this, Dom);
    }

    _createClass(Dom, null, [{
        key: "getSiblings",
        value:
            /**
             * Get all the previous and next siblings, optionally filtered by a selector
             */
            function getSiblings(element, filter) {
                var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var siblings = [];
                var currentElement = element; // Do the previous first

                while (currentElement = currentElement.previousElementSibling) {
                    if (!filter || currentElement.matches(filter)) {
                        siblings.push(currentElement);
                    }
                }

                if (includeSelf) {
                    siblings.push(element);
                } // Then the next side


                currentElement = element;

                while (currentElement = currentElement.nextElementSibling) {
                    if (!filter || currentElement.matches(filter)) {
                        siblings.push(currentElement);
                    }
                }

                return siblings;
            }
        /**
         * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
         * we need to normalize it
         */

    }, {
        key: "nodeListToArray",
        value: function nodeListToArray(nodeList, filter) {
            var items = [];

            for (var i = 0; i !== nodeList.length; ++i) {
                if (!filter || nodeList[i].matches(filter)) {
                    items.push(nodeList[i]);
                }
            }

            return items;
        }
        /**
         * Calculate an element width with its margin
         */

    }, {
        key: "outerWidthWithMargin",
        value: function outerWidthWithMargin(element) {
            var width = element.offsetWidth,
                style = getComputedStyle(element);
            width += parseInt(style.marginLeft) + parseInt(style.marginRight);
            return width;
        }
        /**
         * Calculate an element height with its margin
         */

    }, {
        key: "outerHeightWithMargin",
        value: function outerHeightWithMargin(element) {
            var height = element.offsetHeight,
                style = getComputedStyle(element);
            height += parseInt(style.marginTop) + parseInt(style.marginBottom);
            return height;
        }
    }]);

    return Dom;
}();

var Image = /*#__PURE__*/function () {
    function Image() {
        _classCallCheck(this, Image);
    }

    _createClass(Image, null, [{
        key: "getSizedImageUrl",
        value:
            /**
             * Create a CDN URL (similar to the img_url filter in Liquid)
             */
            function getSizedImageUrl(src, size) {
                if (size === null) {
                    return src;
                }

                if (size === 'master') {
                    return src.replace(/http(s)?:/, '');
                }

                var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

                if (match) {
                    var prefix = src.split(match[0]);
                    var suffix = match[0];
                    return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
                } else {
                    return null;
                }
            }
        /**
         * From a given set of desired sizes and a given image, filter out any unwanted sizes
         */

    }, {
        key: "getSupportedSizes",
        value: function getSupportedSizes(image, desiredSizes) {
            var supportedSizes = [],
                imageWidth = image['width'];
            desiredSizes.forEach(function (width) {
                if (imageWidth >= width) {
                    supportedSizes.push(width);
                }
            });
            return supportedSizes;
        }
    }]);

    return Image;
}();

var Responsive = /*#__PURE__*/function () {
    function Responsive() {
        var _this = this;

        _classCallCheck(this, Responsive);

        this.currentBreakpoint = Responsive.getCurrentBreakpoint();
        window.addEventListener('resize', function () {
            var newBreakpoint = Responsive.getCurrentBreakpoint();

            if (_this.currentBreakpoint === newBreakpoint) {
                return;
            }

            document.dispatchEvent(new CustomEvent('breakpoint:changed', {
                detail: {
                    previousBreakpoint: _this.currentBreakpoint,
                    currentBreakpoint: newBreakpoint
                }
            }));
            _this.currentBreakpoint = newBreakpoint;
        });
    }

    _createClass(Responsive, null, [{
        key: "matchesBreakpoint",
        value: function matchesBreakpoint(breakpoint) {
            switch (breakpoint) {
                case 'phone':
                    return window.matchMedia('screen and (max-width: 640px)').matches;

                case 'tablet':
                    return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

                case 'tablet-and-up':
                    return window.matchMedia('screen and (min-width: 641px)').matches;

                case 'pocket':
                    return window.matchMedia('screen and (max-width: 1007px)').matches;

                case 'lap':
                    return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

                case 'lap-and-up':
                    return window.matchMedia('screen and (min-width: 1008px)').matches;

                case 'desk':
                    return window.matchMedia('screen and (min-width: 1280px)').matches;

                case 'widescreen':
                    return window.matchMedia('screen and (min-width: 1600px)').matches;

                case 'supports-hover':
                    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
            }
        }
    }, {
        key: "getCurrentBreakpoint",
        value: function getCurrentBreakpoint() {
            if (window.matchMedia('screen and (max-width: 640px)').matches) {
                return 'phone';
            }

            if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
                return 'tablet';
            }

            if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
                return 'lap';
            }

            if (window.matchMedia('screen and (min-width: 1280px)').matches) {
                return 'desk';
            }
        }
    }]);

    return Responsive;
}();

var ProductImageZoom = /*#__PURE__*/function () {
    function ProductImageZoom(element, swiperInstance) {
      _classCallCheck(this, ProductImageZoom);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.body);
      this.swiperInstance = swiperInstance;

      this._attachListeners();
    }

    _createClass(ProductImageZoom, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off('click');
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
        this.delegateElement.on('click', '.Product__SlideItem--image', this._initPhotoSwipeFromImageClick.bind(this));
      }
      /**
       * To save performance, we only initialize PhotoSwipe when it's requested. All high resolution images
       * are also loaded only on demand. Also, please note that PhotoSwipe is always completely destroyed
       * whenever it is closed, so it stays super snappy
       */

    }, {
      key: "_initPhotoSwipe",
      value: function _initPhotoSwipe() {
        var images = [];
        this.swiperInstance.slides.forEach(function (item) {
          if (item.element.classList.contains('Product__SlideItem--image')) {
            images.push(item.element.querySelector('img.Image--fadeIn.Image--lazyLoaded'));
          }
        });

        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(this.swiperInstance.realIndex));
      }
      /**
       * On desktop we do not have the dedicated small icon, instead the zoom is triggered when clicking directly on the image
       */

    }, {
      key: "_initPhotoSwipeFromImageClick",
      value: function _initPhotoSwipeFromImageClick(event, target) {
        // Opening this way is only available on desktop
        if (Responsive.matchesBreakpoint('pocket')) {
          return;
        }

        var images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img.Image--fadeIn.Image--lazyLoaded'));

        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(this.swiperInstance.realIndex));
      }
      /**
       * Take a list of images and create a PhotoSwipe array. This is called whenever the gallery is initialized.
       */

    }, {
      key: "_createPhotoSwipeItemsFromImages",
      value: function _createPhotoSwipeItemsFromImages(images) {
        return images.map(function (image) {
          var maxWidth = parseInt(image.getAttribute('data-max-width')),
              maxHeight = parseInt(image.getAttribute('data-max-height')),
              maxDimension = Responsive.matchesBreakpoint('phone') ? 1200 : 1800,
              // 1200 is max size for mobile and 1800 for larger devices
          reduceFactor = 1.0;

          if (maxWidth >= maxHeight) {
            reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
          } else {
            reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
          }

          var requestedWidth = Math.floor(maxWidth / reduceFactor);
          var requestedHeight = Math.floor(maxHeight / reduceFactor);
          return {
            msrc: image.currentSrc || image.src,
            // For browser that supports srcset, currentSrc is the currently used image
            w: requestedWidth,
            h: requestedHeight,
            initialZoomLevel: 0.65,
            src: Image.getSizedImageUrl(image.getAttribute('data-original-src'), requestedWidth + 'x' + requestedHeight)
          };
        });
      }
      /**
       * Take a list of nodes containing all images and create a PhotoSwipe array. This is called
       * whenever the gallery is initialized.
       */

    }, {
      key: "_createPhotoSwipeInstance",
      value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
        var _this = this;

        var photoswipeContainer = document.querySelector('.pswp');
        this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          loop: false,
          history: false,
          closeOnVerticalDrag: false,
          allowPanToNext: false,
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
          scaleMode: 'zoom',
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.6;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {

            var index = index % _this.element.currentVariant.images.length;
            
            var thumbnail = _this.element.querySelector(`.swiper-slide:nth-child(${index + 1}) img`),
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();

            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          }
        }); // We need to patch PhotoSwipe update size to solve iOS 15 issue

        var originalUpdateSize = this.photoSwipeInstance.updateSize,
            lastWidth = null;

        this.photoSwipeInstance.updateSize = function () {
          if (lastWidth === null || lastWidth !== window.innerWidth) {
            originalUpdateSize(this, arguments);
          }

          lastWidth = window.innerWidth;
        };

        this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this));
        this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this));
        this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this));
        this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this));
        this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this));
        this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this));
        this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
        this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
        this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);
        this.photoSwipeInstance.init();
      }
      /**
       * Update the nav
       */

    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged() {
        if (this.photoSwipeInstance.getCurrentIndex() === 0) {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').setAttribute('disabled', 'disabled');
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').removeAttribute('disabled');
        }

        if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').setAttribute('disabled', 'disabled');
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').removeAttribute('disabled');
        }
      }
      /**
       * This event is a bit different and is triggered when the user click somewhere. We use it do allow to zoom in and
       * zoom out in the image on desktop and use for the UI
       */

    }, {
      key: "_onSingleTap",
      value: function _onSingleTap(event) {
        if (!event.detail || event.detail.pointerType === 'mouse') {
          if (event.target.classList.contains('pswp__img')) {
            this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
          }
        } else {
          if (event.target.classList.contains('pswp__button')) {
            return;
          }

          event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
        }
      }
    }, {
      key: "_onDoubleTap",
      value: function _onDoubleTap(point) {
        var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

        if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
          this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
        } else {
          this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
        }
      }
    }, {
      key: "_onInitialZoomIn",
      value: function _onInitialZoomIn() {
        document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
      }
    }, {
      key: "_onInitialZoomOut",
      value: function _onInitialZoomOut() {
        document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
      }
      /**
       * PhotoSwipe instance is automatically destroyed for us when it's closed. What we need to do is simply re-set
       * our in-memory instance to null and our own events
       */

    }, {
      key: "_destroyPhotoSwipe",
      value: function _destroyPhotoSwipe() {
        this.delegateRoot.off('pswpTap');
        this.photoSwipeInstance = null;
      }
    }]);

    return ProductImageZoom;
}();

class VariantGallery extends HTMLElement {
    constructor() {
        super();
        this.variantData = [];
        this.currentVariant = null;
        this.galleryElement = null;
        this.thumbnailSelector = null;
        this.swiperInstance = null; // Store Swiper instance here
    }

    connectedCallback() {
        this.initGallery();
        this.loadVariantData();
        this.listenToVariantChange();
        this.initProductImageZoom();
    }

    initProductImageZoom() {
        if (this.zoomInstance) {
            this.zoomInstance.destroy(); // Destroy the previous zoom instance
        }
        this.zoomInstance = new ProductImageZoom(this, this.swiperInstance);
    }

    loadVariantData() {
        const variantJsonElement = document.querySelector('[data-custom-variant-json]');
        if (variantJsonElement) {
            const data = JSON.parse(variantJsonElement.textContent);
            this.variantData = data.variants;
            this.selectedVariantId = data.selected_variant_id;
            this.updateGallery(this.selectedVariantId);
        } else {
            console.error('Variant JSON data not found!');
        }
    }

    initGallery() {
        this.galleryElement = this.querySelector('.swiper-wrapper');
        if (!this.galleryElement) {
            console.error('Gallery or thumbnail selector not found in the DOM.');
            return;
        }
        this.initializeSwiper();
    }

    listenToVariantChange() {
        document.addEventListener('variant:changed', (event) => {
            const newVariant = event.detail.variant;
            this.updateGallery(newVariant.id);
        });
    }

    updateGallery(variantId) {
        const selectedVariant = this.variantData.find(variant => variant.id === variantId);
        if (selectedVariant && selectedVariant.images) {
            this.currentVariant = selectedVariant;
            this.rebuildGallery();
        }
    }

    rebuildGallery() {
        // Clear out existing images
        this.galleryElement.innerHTML = '';

        // Add new images with lazy loading and span loader
        this.currentVariant.images.forEach(image => {
            const mediaWrapper = document.createElement('div');
            mediaWrapper.classList.add('swiper-slide', 'Product__SlideItem', 'Product__SlideItem--image', 'Carousel__Cell');

            // Create aspect ratio wrapper
            const aspectRatioWrapper = document.createElement('div');
            aspectRatioWrapper.classList.add('AspectRatio', 'AspectRatio--withFallback');
            aspectRatioWrapper.style.paddingBottom = `${100 / image.aspect_ratio}%`;
            aspectRatioWrapper.style.setProperty('--aspect-ratio', image.aspect_ratio);

            // Create discount tag if applicable
            const discountTag = document.createElement('div');
            discountTag.classList.add('hc-sale-tag', 'hc-product-page');
            const discountSpan = document.createElement('span');
            discountTag.appendChild(discountSpan);
            aspectRatioWrapper.appendChild(discountTag);

            // Create image element
            const imgElement = document.createElement('img');
            imgElement.classList.add('Image--lazyLoad', 'Image--fadeIn');
            imgElement.setAttribute('data-src', image.url);
            imgElement.setAttribute('data-original-src', image.original_src || image.url);
            imgElement.setAttribute('alt', image.alt || '');
            imgElement.setAttribute('data-widths', '[200,400,600,800,1000]');
            imgElement.setAttribute('data-max-width', image.width);
            imgElement.setAttribute('data-max-height', image.height);
            aspectRatioWrapper.appendChild(imgElement);

            // Create span loader element
            const loaderSpan = document.createElement('span');
            loaderSpan.classList.add('Image__Loader');
            aspectRatioWrapper.appendChild(loaderSpan);

            // Add no-script fallback for SEO
            const noscript = document.createElement('noscript');
            const fallbackImage = document.createElement('img');
            fallbackImage.src = image.url;
            fallbackImage.setAttribute('data-widths', '[200,400,600,800,1000]');
            fallbackImage.setAttribute('data-max-width', image.width);
            fallbackImage.setAttribute('data-max-height', image.height);
            fallbackImage.setAttribute('data-original-src', image.original_src || image.url);
            fallbackImage.alt = image.alt || '';
            noscript.appendChild(fallbackImage);
            aspectRatioWrapper.appendChild(noscript);

            // Append everything to the wrapper
            mediaWrapper.appendChild(aspectRatioWrapper);
            this.galleryElement.appendChild(mediaWrapper);
        });
        
        this.updateThumbnailSelector();        
        this.updateDiscountBadge();

        // Re-initialize Swiper or update it with the new slides
        if (this.swiperInstance) {
            this.swiperInstance.update(); // Update existing Swiper instance to reflect new slides
        } else {
            this.initializeSwiper(); // Initialize Swiper for the first time
        }
    }


    initializeSwiper() {

        var _this = this;
        
        const swiperConfig = {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            navigation: {
                nextEl: '.Product__SlideshowNavArrow--next',
                prevEl: '.Product__SlideshowNavArrow--previous',
            },
            on: {
                init: (swiperInstance) => {

                    _this.interactWithLazyLoading();

                    setTimeout(function () {
                        if (swiperInstance)
                            _this.createDots();
                            _this.setActiveThumbnail(swiperInstance.realIndex || 0);
                            _this.setActiveDot(swiperInstance.realIndex || 0);
                            _this.updateNavigationButtons(swiperInstance);
                    }, 100)
                },
                slideChange: (swiperInstance) => {
                    setTimeout(function () {
                        if (swiperInstance) {
                            _this.setActiveThumbnail(swiperInstance.realIndex);
                            _this.setActiveDot(swiperInstance.realIndex);
                            _this.updateNavigationButtons(swiperInstance);
                        }
                    }, 100)
                }
            }
        };

        if (this.swiperInstance) {
            try {
                this.swiperInstance.destroy(true, true);
            } catch (error) {
                console.warn("Swiper instance could not be destroyed:", error);
            }
            this.swiperInstance = null;
        }

        this.swiperInstance = new Swiper(this.querySelector('.swiper-container'), swiperConfig);
    }

    interactWithLazyLoading() {
        const slides = this.galleryElement.querySelectorAll('.Product__SlideItem');
        slides.forEach((slide) => {
            const images = slide.querySelectorAll('.Image--lazyLoad, .Image--lazyLoading');
            images.forEach((image) => {
                image.addEventListener('lazyloaded', () => this._slideEnter(slide));
            });
        });
    }

    _slideEnter(slide) { }

    updateDiscountBadge() {
        const saleTagContainers = this.querySelectorAll('.hc-sale-tag');
        const price = this.currentVariant.price;
        const compareAtPrice = this.currentVariant.compare_at_price;
        let discount = 0;
        if (compareAtPrice > price) {
            discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
        }
        if (discount > 0) {
            saleTagContainers.forEach(item => {
                item.style.display = 'block';
                item.querySelector('span').textContent = `${discount}%`;
            });
        } else {
            saleTagContainers.forEach(item => {
                item.style.display = 'none';
            });
        }
    }

    updateThumbnailSelector() {
        this.thumbnailSelector = this.querySelector('.swiper-pagination');
        this.thumbnailSelector.innerHTML = '';

        // Loop through current variant images to generate thumbnails
        this.currentVariant.images.forEach((image, index) => {
            const thumbElement = document.createElement('img');
            thumbElement.src = image.url;
            thumbElement.classList.add('thumbnail');

            // Add 'click' event to change the slide
            thumbElement.addEventListener('click', () => {
                this.changeSlide(index);
                this.setActiveThumbnail(index);
            });

            this.thumbnailSelector.appendChild(thumbElement);
        });

        // Set the active class for the initial active thumbnail
        this.setActiveThumbnail(this.swiperInstance.realIndex || 0);
    }

    setActiveThumbnail(activeIndex) {
        const thumbnails = this.thumbnailSelector.querySelectorAll('.thumbnail');
        thumbnails.forEach(thumb => thumb.classList.remove('active-thumbnail'));
    
        const activeThumb = thumbnails[activeIndex];
        if (activeThumb) {
            activeThumb.classList.add('active-thumbnail');
        }
    }

    changeSlide(index) {
        if (this.swiperInstance) {
            this.swiperInstance.slideTo(index, 500);
        }
    }
    
    createDots() {
        const dotContainer = this.querySelector('.flickity-page-dots');
        dotContainer.innerHTML = ''; // Clear previous dots if any
    
        // Create dots based on the number of slides
        this.swiperInstance.slides.forEach((slide, index) => {
            const dotButton = document.createElement('button');
            dotButton.classList.add('dot');
            dotButton.setAttribute('type', 'button');
            dotButton.setAttribute('aria-label', 'slide-dot');
    
            // Add click event to jump to the corresponding slide
            dotButton.addEventListener('click', () => {
                this.swiperInstance.slideTo(index);
            });
    
            dotContainer.appendChild(dotButton);
        });
    }
    
    setActiveDot(activeIndex) {
        const dots = this.querySelectorAll('.flickity-page-dots .dot');
        dots.forEach((dot, index) => {
            if (index === activeIndex) {
                dot.classList.add('is-selected');
            } else {
                dot.classList.remove('is-selected');
            }
        });
    }

    updateNavigationButtons(swiperInstance) {
        const prevButton = document.querySelector('.Product__SlideshowNavArrow--previous');
        const nextButton = document.querySelector('.Product__SlideshowNavArrow--next');
    
        // Disable "prev" button if on the first slide
        if (swiperInstance.isBeginning) {
            prevButton.setAttribute('disabled', true);
        } else {
            prevButton.removeAttribute('disabled');
        }
    
        // Disable "next" button if on the last slide
        if (swiperInstance.isEnd) {
            nextButton.setAttribute('disabled', true);
        } else {
            nextButton.removeAttribute('disabled');
        }
    }
}

customElements.define('variant-gallery', VariantGallery);
